import { render, staticRenderFns } from "./orderHandover.vue?vue&type=template&id=adcd7bca&"
import script from "./orderHandover.vue?vue&type=script&lang=js&"
export * from "./orderHandover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports